// extracted by mini-css-extract-plugin
export const accountsTable = "HomeSettingsModule__accountsTable__ndatm";
export const atlasGrotesk = "'AtlasGrotesk'";
export const body = "HomeSettingsModule__body__3tHDK";
export const bold = "700";
export const cell = "HomeSettingsModule__cell__Cw1TH";
export const creditAccountDetails = "HomeSettingsModule__creditAccountDetails__gc5eR";
export const debtsAccountDetails = "HomeSettingsModule__debtsAccountDetails__KQFK3";
export const down = "HomeSettingsModule__down__Qku4U";
export const emptyState = "HomeSettingsModule__emptyState__DiMo8 BalanceAccountSettingsModule__emptyState__shYhk";
export const footer = "HomeSettingsModule__footer__Cl-VM";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const headerCell = "HomeSettingsModule__headerCell__OT12g";
export const headerRow = "HomeSettingsModule__headerRow__8rZ5y";
export const headerTitle = "HomeSettingsModule__headerTitle__vXD3W";
export const homesTable = "HomeSettingsModule__homesTable__7uy6o";
export const medium = "500";
export const pageSizeSelectorWrapper = "HomeSettingsModule__pageSizeSelectorWrapper__wU3jZ";
export const paginatorWrapper = "HomeSettingsModule__paginatorWrapper__N6YRc";
export const pointing = "HomeSettingsModule__pointing__928KQ";
export const regular = "400";
export const responsiveTitle = "HomeSettingsModule__responsiveTitle__TvoY+";
export const responsiveTitleText = "HomeSettingsModule__responsiveTitleText__ti+oC";
export const row = "HomeSettingsModule__row__LaFB5";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const sortingWrapper = "HomeSettingsModule__sortingWrapper__XmiLj";
export const table = "HomeSettingsModule__table__P0xEk";
export const tableInner = "HomeSettingsModule__tableInner__lw42Y";
export const textCenter = "HomeSettingsModule__textCenter__cTTr1";
export const tooltipIconWrapper = "HomeSettingsModule__tooltipIconWrapper__tgMxh";
export const up = "HomeSettingsModule__up__gyJ7V";
export const visibleOneColumnUp = "HomeSettingsModule__visibleOneColumnUp__eshcL";
export const white = "HomeSettingsModule__white__2udgA";
export const withHelpText = "HomeSettingsModule__withHelpText__wgvgo";